import { TimerExtras } from "../../lib/timer";
import { Annotations } from "../../lib/userdata";
import {
	AttemptId,
	ItemId,
	ProductId,
} from "../datasource";
import {
	AnswerValue, ContentItem, ItemDataSource, ItemUsage,
	NullItemDataSource
} from "../datasource/item";

export abstract class ItemModel<P extends ProductId, A extends AttemptId, I extends ItemId, E extends TimerExtras> {
	datasource: ItemDataSource<P, A, I, E>;

	protected constructor(datasource?: ItemDataSource<P, A, I, E>) {
		this.datasource = datasource ?? new NullItemDataSource();
	}

	abstract getItem(product: P, id: I, randomize: boolean): Promise<ContentItem<I>>
	abstract getSameContexts(a: ContentItem<I>, b: ContentItem<I>): ContentItem<I>["contexts"]
	abstract setUserData(product: P, attempt: A, item: I, data: Annotations): Promise<AnswerValue<A, I>>
	abstract setPing(product: P, attempt: A, times: ItemUsage<I, E>[]): Promise<void>
	abstract setFinished(product: P, attempt: A): Promise<string>
}

export class NullItemModel<P extends ProductId, A extends AttemptId, I extends ItemId> implements ItemModel<P, A, I, never> {
	datasource: ItemDataSource<P, A, I, never>;

	getItem(product: P, id: I, randomize: boolean): Promise<ContentItem<I>> {
		throw new Error("Method not implemented.");
	}

	getSameContexts(a: ContentItem<I>, b: ContentItem<I>): ContentItem<I>["contexts"] {
		throw new Error("Method not implemented.");
	}

	setUserData(product: P, attempt: A, item: I, data: Annotations): Promise<AnswerValue<A, I>> {
		throw new Error("Method not implemented.");
	}

	setPing(product: P, attempt: A, times: ItemUsage<I, never>[]): Promise<void> {
		throw new Error("Method not implemented.");
	}

	setFinished(product: P, attempt: A): Promise<string> {
		throw new Error("Method not implemented.");
	}
}

